import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { ListCell } from '@src/components/table-list/cells'
import { Subtitle1 } from '@src/elements/typography/typography'

@Component
export class StatusCell extends ListCell {

  item: string

  render (h: CreateElement) {
    return <Subtitle1 class={`cell ${this.item[this.name]}`}>{this.$t(`PAGE.MEMBERS.ACTIVITIES.STATUS.${this.item[this.name].toUpperCase()}`)}</Subtitle1>
  }
}
